// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__10fCl","footer":"ModalUpdate_footer__3Gtzl"};